export default "__VITE_ASSET__y56QUrXg__"